require('./src/webpush-client.js');
module.exports = window.WebPushClientFactory;